import { z } from 'zod';

export const CreateReverseProposalServiceRequestSchema = z
  .object({
    goodsNo: z.number().min(1),
    startAt: z.string().regex(/\d{8}/),
    message: z.string(),
  })
  .describe('CreateReverseProposalServiceRequestSchema');

export type CreateReverseProposalServiceRequest = z.infer<
  typeof CreateReverseProposalServiceRequestSchema
>;

export const CreateReverseProposalServiceResponseSchema = z.object({
  id: z.number(),
});

export type CreateReverseProposalServiceResponse = z.infer<
  typeof CreateReverseProposalServiceResponseSchema
>;
